import React, {useEffect} from 'react';
import ReactPlayer from "react-player";

const MyPlayer = (props) => {
    useEffect(() =>{

    }, [props?.selectCamerasOpen])
    return (
        <ReactPlayer
            // url={props?.selectCameras}
            // url="https://hls2.cradle-vision.com/stream/hls_office/index.m3u8"
            className=" w-65   h-100 "
            style={{borderRadius: "8px", marginLeft: "auto", marginRight: "auto"}}
            playing={true}
            muted/>
    );
};

export default MyPlayer;